import styled, { css } from 'styled-components';
import blurBg from '../../assets/images/blur_bg.png';

const StyledContainer = styled.div<{ $expanded: boolean }>`
	position: relative;
	width: 440px;
	height: 100px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;

	${(props) =>
		!props.$expanded &&
		css`
			height: 0;
			border: 0px solid rgba(255, 255, 255, 0.1);
		`}
	transition: height 0.25s ease, border 0.25s ease;
`;

const StyledTextContainer = styled.div`
	position: absolute;
	top: 30px;
	left: 30px;
	display: flex;
	flex-direction: column;
	gap: 6px;
	color: #ffffff;
`;

const StyledBlurBg = styled.div`
	position: absolute;
	right: -270px;
	top: 50%;
	transform: translateY(-50%);
	width: 540px;
	height: 540px;
	mask-image: url(${blurBg});
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${blurBg});
	-webkit-mask-size: cover;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
`;

const StyledSvg = styled.svg`
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 160px;
	height: 160px;
	z-index: 2;
`;

const StyledCaseImage = styled.img.attrs({
	width: 100,
	height: 100,
})`
	position: absolute;
	right: 30px;
	top: 0;
	z-index: 3;
	user-select: none;
	pointer-events: none;
`;

export {
	StyledBlurBg,
	StyledCaseImage,
	StyledContainer,
	StyledSvg,
	StyledTextContainer,
};
